const produto = (DataBase, Datatype) => {
	const Produto = DataBase.new(
		{
			id_fornecedor: Datatype.STRING,
			nome: Datatype.STRING,
			descricao: Datatype.STRING,
			lucro: Datatype.NUMBER,
			quantidade: Datatype.NUMBER,
			t_lucro: Datatype.NUMBER,
			c_barras: Datatype.STRING,
			categorias: Datatype.ARRAY,
		},
		{
			tracked: true,
			dateLogs: true,
			softDelete: true,
			collection: "produto",
			model: "Produto",
		}
	);

	Produto.defaults = {
		quantidade: 0,
	};

	Produto.relate = (models) => [
		{
			model: models.Fornecedor,
			fk: "id_fornecedor",
			name: "fornecedor",
		},
	];

	Produto.assume = (models) => [
		{
			model: models.ProdutoFluxo,
			name: "fluxo",
		},
	];

	return Produto;
};

export default produto;
